import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UserChannel } from "@/models/Channel";
import { computed, onMounted, ref } from "vue";
import { useUserChannelsStore } from "@/store/pinia_userChannel";
import { storeToRefs } from "pinia";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  required: { type: Boolean, required: false, default: true },
  modelValue: { type: UserChannel, required: false },
  label: { type: String, required: false, default: "Channels" },
  emailOnly: { type: Boolean, required: false, default: false },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef

const userChannelsStore = useUserChannelsStore();
onMounted(() => {
  userChannelsStore.setupChannels();
});

const selectedChannel = computed({
  get: (): UserChannel | undefined => {
    return props.modelValue;
  },
  set: (val: UserChannel | undefined) => {
    const newVal = userChannelsStore.userChannels.find((c) => c.id == val?.id);
    emit("update:modelValue", newVal);
  },
});

const messages = props.required ? "Required" : "";
const { userChannels, activeEmailChannels } = storeToRefs(userChannelsStore);

return (_ctx: any,_cache: any) => {
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createBlock(_component_va_select, {
    options: __props.emailOnly ? _unref(activeEmailChannels) : _unref(userChannels),
    label: __props.label,
    modelValue: _unref(selectedChannel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedChannel) ? (selectedChannel).value = $event : null)),
    "text-by": "name",
    "track-by": "id",
    messages: _unref(messages)
  }, null, 8, ["options", "label", "modelValue", "messages"]))
}
}

})